<template>
  <v-container fluid class="tp-page">
    <div class="tp-page-head">
      <div>
        <h1 class="tp-page-title">Auditoria</h1>
        <p class="tp-page-sub">{{ registros.length }} registro(s) de uso · logins e ações no sistema</p>
      </div>
      <div class="tp-head-actions">
        <v-select
          v-model="filtroAcao"
          :items="acoesDisponiveis"
          label="Ação"
          outlined dense hide-details color="#00695C"
          style="max-width: 180px"
          clearable
        ></v-select>
        <v-text-field
          v-model="busca"
          prepend-inner-icon="mdi-magnify" placeholder="Buscar…"
          hide-details dense outlined color="#00695C" class="tp-search"
        ></v-text-field>
        <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" :loading="carregando" @click="carregar">
          <v-icon left>mdi-refresh</v-icon>Atualizar
        </v-btn>
      </div>
    </div>

    <v-card class="tp-card" elevation="0">
      <v-data-table
        :headers="cabecalho"
        :items="registrosFiltrados"
        :search="busca"
        :loading="carregando"
        loading-text="Carregando registros…"
        :items-per-page="25"
        sort-by="created"
        sort-desc
        :footer-props="{ 'items-per-page-options': [25, 50, 100] }"
      >
        <template v-slot:[`item.created`]="{ item }">
          {{ formatarData(item.created) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          <v-chip small label :color="corAcao(item.acao)" dark>{{ item.acao }}</v-chip>
        </template>
        <template v-slot:[`item.usuarioNome`]="{ item }">
          <div class="d-flex align-center">
            <v-avatar size="30" color="#00695C" class="mr-2">
              <span style="color:#fff;font-size:.72rem;font-weight:700">{{ iniciais(item.usuarioNome) }}</span>
            </v-avatar>
            <div>
              <div style="font-weight:500">{{ item.usuarioNome || '—' }}</div>
              <div style="font-size:.72rem;color:#8895a0">{{ item.usuarioEmail }}</div>
            </div>
          </div>
        </template>
        <template v-slot:no-data>
          <v-alert dense text outlined :value="true" color="info" icon="info" class="ma-3">Nenhum registro de auditoria encontrado.</v-alert>
        </template>
      </v-data-table>
    </v-card>

    <loading :active.sync="carregando" :can-cancel="true" color="#00695C" :is-full-page="false"></loading>
    <Snackbar ref="chamaSnackbar" />
  </v-container>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import moment from 'moment'
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import { mapState } from 'vuex'

export default {
  name: 'Auditoria',
  components: { Loading, Snackbar },
  data() {
    return {
      carregando: false,
      busca: '',
      filtroAcao: null,
      registros: [],
      acoesDisponiveis: ['LOGIN', 'CRIAR', 'EDITAR', 'EXCLUIR', 'CRIAR/EDITAR'],
      cabecalho: [
        { text: 'Data/Hora', value: 'created' },
        { text: 'Usuário', value: 'usuarioNome' },
        { text: 'Ação', value: 'acao', align: 'center' },
        { text: 'Entidade', value: 'entidade' },
        { text: 'Descrição', value: 'descricao' },
        { text: 'IP', value: 'ip' },
      ],
    }
  },
  computed: {
    ...mapState({ user: state => state.userObj }),
    registrosFiltrados() {
      if (!this.filtroAcao) return this.registros
      return this.registros.filter(r => r.acao === this.filtroAcao)
    },
  },
  mounted() {
    this.carregar()
  },
  methods: {
    async carregar() {
      this.carregando = true
      try {
        const token = sessionStorage.getItem('accToken')
        const filtro = {
          where: { igrejaId: this.user.igrejaId },
          order: 'created DESC',
          limit: 500,
        }
        const res = await axios.get(`${baseApiUrl}Auditorias?filter=${encodeURIComponent(JSON.stringify(filtro))}&access_token=${token}`)
        this.registros = res.data || []
      } catch (e) {
        if (this.$refs.chamaSnackbar) {
          this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao carregar registros de auditoria.', 'ERRO')
        }
      } finally {
        this.carregando = false
      }
    },
    formatarData(d) {
      return d ? moment(d).format('DD/MM/YYYY HH:mm:ss') : '—'
    },
    iniciais(nome) {
      const n = (nome || '').trim()
      if (!n) return '?'
      const p = n.split(' ').filter(Boolean)
      return ((p[0] || '')[0] + (p.length > 1 ? p[p.length - 1][0] : '')).toUpperCase()
    },
    corAcao(acao) {
      switch (acao) {
        case 'LOGIN': return '#00695C'
        case 'CRIAR': return '#2E9E78'
        case 'EDITAR': return '#15AAF4'
        case 'CRIAR/EDITAR': return '#0E8C76'
        case 'EXCLUIR': return '#EF5350'
        default: return '#90A4AE'
      }
    },
  },
}
</script>
